import React from 'react';
import { Row, Col } from 'reactstrap';
import ProductCategoryLink from '../ProductCategoryLink';
import Link from 'next/link';
import _ from 'lodash';

import ArticleHeart from './ArticleHeart';

// @ts-ignore
import ArticleImage from 'flaivy-react/components/article/ArticleImage';
// @ts-ignore
import ArticleQuantityInput from 'flaivy-react/components/cart/CartArticleQuantityInput';

import ArticleBadges from './ArticleBadges';
import LoginToShowPrices from '../LoginToShowPrices';
import type { ArticleReference } from 'domain-model/types/oms';
import DiscountFlag from './DiscountFlag';

function ArticleCardImage({ article }: { article: ArticleReference }) {
  const { id, shortName } = article;

  return (
    <>
      <div className="position-relative">
        <div className="shopFavoritesWrapper float-end">
          <ArticleHeart article={article} />
        </div>
        <ArticleBadges article={article} />
      </div>

      <div className="d-flex justify-content-center align-items-center">
        <div className="product-image">
          <div className="text-center py-2 position-relative float-end">
            <Link href={`/articles/${id}`}>
              <ArticleImage
                article={article}
                alt={shortName}
                resX={148}
                resY={148}
                className="img-fluid article-image"
              />
            </Link>
          </div>
        </div>
      </div>
      <DiscountFlag article={article} />
    </>
  );
}

function ArticleCardTitle({ article }: { article: ArticleReference }) {
  const { id, productCategory, organizationProductCategory } = article;

  return (
    <>
      <div className="px-2 title-box">
        {(productCategory || organizationProductCategory) && (
          <ProductCategoryLink
            productCategory={productCategory}
            organizationProductCategory={organizationProductCategory}
            className="text-dark text-xs"
          />
        )}
        {!productCategory && <br />}
        <h6 className="mx-0 my-1 overflow-hidden article-card-title text-truncate">
          <Link href={`/articles/${id}`} className="text-dark ">
            {article.shortName}
          </Link>
        </h6>
        <p className="mb-0 text-sm fw-light text-truncate">
          {String(_.get(article, 'brand.name', ''))} <br />
        </p>
      </div>
    </>
  );
}

function ArticleCardGrid({ article }: { article: ArticleReference }) {
  return (
    <LoginToShowPrices>
      <ArticleQuantityInput
        {...{
          article,
        }}
      />
    </LoginToShowPrices>
  );
}

export function ArticleCarouselCard({
  article,
}: {
  article: ArticleReference;
}) {
  const { id } = article;
  return (
    <Row
      id={`article-carousel-card-${id}`}
      className="g-0 h-100 article-card article-carousel-card"
    >
      <Col xs={12} className="article-card-image pt-md-2">
        <ArticleCardImage article={article} />
      </Col>
      <Col xs={12}>
        <Row className="g-0 align-items-start article-card-info-wrapper">
          <Col xs={12} className="align-self-end article-card-info">
            <ArticleCardTitle article={article} />
          </Col>

          <Col xs={12} className="article-card-grid align-self-end">
            <ArticleCardGrid article={article} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

function ArticleCard({ article }: { article: ArticleReference }) {
  const { id } = article;

  return (
    <Row id={`article-mobile-${id}`} className="g-0 h-100 article-card">
      <Col xs={4} md={12} className="article-card-image pt-1 pt-lg-2">
        <ArticleCardImage article={article} />
      </Col>
      <Col xs={8} md={12}>
        <Row className="g-0 align-items-start article-card-info-wrapper">
          <Col xs={12} className="align-self-end article-card-info">
            <ArticleCardTitle article={article} />
          </Col>

          <Col xs={12} className="article-card-grid align-self-end">
            <ArticleCardGrid article={article} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default ArticleCard;
